import { FUND_SUMMARY_SPREADSHEET_COLUMNS } from 'pages/Funds/common/constants/fundSummary/sheetTitles';

const getAdjustedColumns = (isProcessManagementEnabled: boolean) => {
  if (isProcessManagementEnabled) {
    return FUND_SUMMARY_SPREADSHEET_COLUMNS;
  }

  let adjustedColumns = { ...FUND_SUMMARY_SPREADSHEET_COLUMNS };
  type FundSummaryColumnsKey = keyof typeof FUND_SUMMARY_SPREADSHEET_COLUMNS;

  Object.entries(FUND_SUMMARY_SPREADSHEET_COLUMNS).forEach(([key, value]) => {
    const columnKey = key as FundSummaryColumnsKey;

    if (columnKey !== Object.keys(FUND_SUMMARY_SPREADSHEET_COLUMNS)[0]) {
      adjustedColumns = { ...adjustedColumns, [columnKey]: value - 1 };
    }
  });

  return adjustedColumns;
};

export default getAdjustedColumns;
